const HRFinalFeedback = () => {
	return `mutation HRFinalFeedback(
    $appraisal_id: String!
    $manager_comments: String
    $appraisee_comments: String
  ){
    hrFinalFeedback(
      appraisal_id: $appraisal_id
      manager_comments: $manager_comments
      appraisee_comments: $appraisee_comments
    )
  }`;
}

export default HRFinalFeedback;